import {Grid, Typography, withStyles, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@material-ui/core'

import React, {Component} from 'react'
import {connect} from 'react-redux'
import CollectionCrud from '../../common/Components/CollectionCrud'
import AttentesCss from './css/AttentesCss'
import { collectionActions, sendAttenteMail } from '../../../reducers/collectionsReducer'
import { CheckCircle, RadioButtonUnchecked } from '@material-ui/icons'

class Attentes extends Component {
  state = {
    open: false,
  };

  componentDidMount() {
    let {dispatch} = this.props;
    collectionActions(
      dispatch,
      'sejours',
      'SHOW',
      {uuid: this.props.match.params.uuid},
    )

    collectionActions(
      dispatch,
      'attentes',
      'INDEX',
      {params: {sejour_uuid: this.props.match.params.uuid}}
    )
  }

  getTitle() {
    if (this.props.sejoursStore.detail) {
      return 'pour séjour ' + this.props.sejoursStore.detail.libelle
        + ' du ' + this.getDate(this.props.sejoursStore.detail.date_debut)
        + ' au ' + this.getDate(this.props.sejoursStore.detail.date_fin)
    }
    return null
  }

  getDateTime(string) {
    if (!string) {
      return ''
    }
    let date = new Date(string)
    let options = {day: 'numeric', month: 'numeric', year: 'numeric'}
    return date.toLocaleTimeString('fr-FR', options)
  }

  getDate(string) {
    if (!string) {
      return ''
    }
    let date = new Date(string)
    let options = {day: 'numeric', month: 'numeric', year: 'numeric'}
    return date.toLocaleDateString('fr-FR', options)
  }

  handleEnvoyerClick = () => {
    sendAttenteMail(
      this.props.dispatch,
      this.props.match.params.uuid,
      () => {}
    )
  }

  handleClickOpen = () => {
    const emailsToSend = this.props.attentesStore.list.filter(attente => !attente.mail_envoye).length;
    this.setState({ open: true, emailsToSend });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleConfirm = () => {
    this.handleEnvoyerClick();
    this.handleClose();
  };

  render() {
    const {classes} = this.props

    return (
      <Grid container spacing={2} className={classes.container}>
        <Grid item xs={8}>
          <Typography
            variant="button"
            gutterBottom
            className={classes.sectionTitle}
          >
            Liste d'attente pour {this.getTitle()}
          </Typography>
        </Grid>

        <Grid item xs={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleClickOpen}
            title="Envoyer un mail indiquant que des places sont disponibles sur ce séjour aux personnes en attente"
          >
            Envoyer les mails
          </Button>
        </Grid>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
        >
          <DialogTitle>Confirmer l'envoi</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Êtes-vous sûr de vouloir envoyer un mail indiquant que des places sont disponibles sur ce séjour aux personnes pour qui le mail n'a pas encore été envoyé ? (mails envoyés : {this.state.emailsToSend})
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Annuler
            </Button>
            <Button onClick={this.handleConfirm} color="primary" autoFocus>
              Confirmer
            </Button>
          </DialogActions>
        </Dialog>

        <CollectionCrud
          collectionName={'attentes'}
          loadDatas={false}
          showBtnEdit={false}
          showBtnAdd={false}
          showBtnDelete={false}
          datatableConfig={{
            showPagination: true,
            showSearch: true,
            rowsPerPageOptions: [20, 50, 100],
          }}
          cellsConfig={[
            {
              datakey: 'created_at',
              title: 'Date ajout',
              sortable: true,
              searchable: true,
              format: (obj, key) => {
                return this.getDateTime(obj[key])
              },
            },
            {
              datakey: 'email',
              title: 'Email',
              sortable: true,
              searchable: true,
            },
            {
              datakey: 'mail_envoye',
              title: 'Mail envoyé',
              sortable: true,
              searchable: false,
              format: (obj, key) => {
                return !!obj[key]
                  ? <CheckCircle color="primary"/>  // 'Oui'
                  : <RadioButtonUnchecked/>  // 'Non'
              },
            },

          ]}
        />
      </Grid>
    );
  }
}

Attentes = withStyles(AttentesCss)(Attentes)

Attentes = connect((store) => {
  return {
    sejoursStore: store.collections.sejours,
    signaturesStore: store.collections.signatures,
    attentesStore: store.collections.attentes,
  }
})(Attentes);

export default Attentes
